import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=6556a550&scoped=true"
import script from "./Hero.js?vue&type=script&lang=js&external"
export * from "./Hero.js?vue&type=script&lang=js&external"
import style0 from "./Hero.scss?vue&type=style&index=0&id=6556a550&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6556a550",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Image/Image.vue').default,HotTitle: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Title/Title.vue').default,HotButton: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/Button/Button.vue').default,HotLink: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Link/Link.vue').default})
